module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n&nbsp;\n\n# Level 1 Icon\n\n## Notes\n\n&nbsp;\n\n&nbsp;\n\n# Level 2 Start\n\n## Notes\n\n&nbsp;\n\n# Level 2 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 3 Start\n\n## Notes\n\n&nbsp;\n\n# Level 3 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 4 Start\n\n## Notes\n\n&nbsp;\n\n# Level 4 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 5 Start\n\n## Notes\n\n&nbsp;\n\n# Level 5 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 6 Start\n\n## Notes\n\n&nbsp;\n\n# Level 6 Icon\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/01_start/start.fr_CA.md
// module id = 1671
// module chunks = 2